import * as React from "react";
import { useEffect } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const TransactionRow = ({ transaction, transactions }: any) => {
  return (
    <>
      <TableRow>
        <TableCell align="center">
          #{transaction?.transactionId?.slice(-6)}
        </TableCell>

        {/* Date Time */}
        <TableCell align="center">
          {new Date(transaction.paymentDate).toLocaleString("en-US", {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
          })}
        </TableCell>

        {/* Start Balance */}
        <TableCell align="center">
          {(() => {
            switch (transaction.type) {
              case "CaptureFees":
                return "- £ " + transaction.startBalance;
              case "AuthorizationFees":
                return "- £ " + transaction.startBalance;
              case "ProcessingFees":
                return "- £" + transaction.startBalance;
              case "AssessmentFees":
                return "- £" + transaction.startBalance;
              case "InterchangeFees":
                return "- £" + transaction.startBalance;
              case "PaidPaymentDetails":
                return "- £" + transaction.startBalance;
              case "Refund":
                return "£ " + transaction.startBalance;
              case "Withdraw":
                return "£ " + transaction.startBalance;
              case "WithdrawFees":
                return "£" + transaction.startBalance;
              case "GatewayFees":
                return "- £" + transaction.startBalance;
              case "RefundFees":
                return "£ " + transaction.startBalance;
              case "GatewayFeesR":
                return "£ " + transaction.startBalance;
            }
          })()}

          {/* £ {transaction.startBalance}  */}
        </TableCell>

        {/* Transaction Amount */}
        <TableCell align="center">
          {(() => {
            switch (transaction.type) {
              case "AuthorizationFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "CaptureFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "ProcessingFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "AssessmentFees":
                return (
                  "- £" + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "InterchangeFees":
                return (
                  "- £" + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "PaidPaymentDetails":
                return (
                  "£ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "Refund":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "Withdraw":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "WithdrawFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "GatewayFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              case "RefundFees":
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
              default:
                return (
                  "- £ " + Math.abs(transaction.transactionAmount).toFixed(2)
                );
            }
          })()}
        </TableCell>

        {/* Transaction Type */}
        <TableCell align="center">
          {transaction.type === "GatewayFeesR"
            ? "GatewayFees"
            : transaction.type === "WithdrawFees"
            ? "WithdrawalFees"
            : transaction.type == "Withdraw"
            ? "Withdrawal"
            : transaction.type}
        </TableCell>

        {/* Total Fees */}
        <TableCell align="center">
          {(() => {
            const abs = (val) => Math.abs(val || 0).toFixed(2);
            const feeSumBefore = transactions
              .filter(
                (t, i) =>
                  t.paymentDate <= transaction.paymentDate &&
                  t.type.includes("Fees")
              )
              .reduce((sum, t) => sum + Math.abs(t.transactionAmount || 0), 0);

            switch (transaction.type) {
              case "AuthorizationFees":
              case "CaptureFees":
              case "ProcessingFees":
              case "InterchangeFees":
              case "AssessmentFees":
                return `£${abs(feeSumBefore.toFixed(2))}`;

              case "Withdraw":
              case "Refund":
                return "N/A";

              case "WithdrawFees":
                return `£${abs(feeSumBefore.toFixed(2))}`;

              default:
                return `£${feeSumBefore.toFixed(2)}`;
            }
          })()}
        </TableCell>
        <TableCell align="center">
          £{transaction.totalAmount.toFixed(2)}
        </TableCell>
        {/* Withdrawable Balance */}
        {/* {transaction.type === "Refund" ? (
          <TableCell align="center">
            £{transaction.totalAmount.toFixed(2)}
          </TableCell>
        ) : (
          <TableCell align="center">
            {(() => {
              const amount = Math.abs(transaction.transactionAmount || 0);
              const total = Math.abs(transaction.totalAmount || 0);
              const start = Math.abs(transaction.startBalance || 0);

              switch (transaction.type) {
                case "AuthorizationFees":
                case "CaptureFees":
                case "ProcessingFees":
                case "GatewayFees":
                case "InterchangeFees":
                case "AssessmentFees":
                  return `- £ ${(start + amount).toFixed(2)}`;

                case "PaidPaymentDetails":
                  return `£ ${(amount - total).toFixed(2)}`;

                case "Withdraw":
                case "WithdrawFees":
                case "Refund":
                case "RefundFees":
                case "GatewayFeesR":
                  return `£ ${(start - amount).toFixed(2)}`;

                default:
                  return `£ ${amount.toFixed(2)}`;
              }
            })()}
          </TableCell>
        )} */}
      </TableRow>
    </>
  );
};

export default TransactionRow;
